<!------------------------------------------------------------------------------
  - Copyright (c) 2024. dnote.ai
  -
  - @project DNOTE.AI-Frontend
  - @author dnote.ai
  - @copyright Dnote.ai All rights reserved
  ----------------------------------------------------------------------------->

<template>
    <DashboardContainer :style="'px-0 mx-0'">
        <CheatCode/>
	    
	    <div class="mt-4">
		   <DashboardCard
    header-title="Template"
    :refreshButton="true"
    @refresh="resetTemplate">

			    <div class="row">
				    <div class="col-md-6 mb-4">
					    <InputText placeholder="Template name"
					               v-model="template.name" class="w-100"/>
				    </div>
				    
				    <div class="col-md-6 mb-4">
					    <Select placeholder="Template Style"
					            :options="templateStyle"
					            optionLabel="label"
					            optionValue="value"
					            v-model="template.templateStyle" class="w-100"/>
				    </div>
		
					
				    <div class="col-md-12 mb-4">
					    <FormLabel label-text="Communication Way"
					               :required="true"/>
					    <Select placeholder="Template Use case"
					                 :options="communicationWays"
					                 optionLabel="label"
					                 optionValue="value"
					                 v-model="template.communicationWays"
					                 class="w-100"/>
				    </div>

                    <!-- added date is 09/06/2026 -->
                <div
    class="col-md-12 mb-4"
    v-if="[
        'SMS_OTP',
        'SMS_RECEIPT',
        'EMAIL_OTP',
        'EMAIL_RECEIPT',
        'WHATSAPP_RECEIPT'
    ].includes(template.templateStyle)"
>
    <div class="form-check">
        <input
            class="form-check-input"
            type="checkbox"
            id="activeTemplate"
            v-model="template.active">

        <label
            class="form-check-label"
            for="activeTemplate">
            Set as Active Template
        </label>
    </div>
</div>
				    
				    <div class="col-md-12"
				         v-if="template.communicationWays!==null && template.communicationWays.includes('MAIL')">
					    <FormLabel label-text="Email Message"
					               :required="false"/>
					    <Editor editorStyle="height: 220px"
					            v-model="template.emailText"
					            class="w-100"/>
				    </div>
				    
				    <div class="col-md-6 mb-4"
				         v-if="template.communicationWays!==null && template.communicationWays.includes('WHATSAPP')">
					    <FormLabel label-text="WhatsApp Template Language"
					               :required="true"/>
					    <Select v-model="template.language"
					            :options="whatsappLanguages"
					            placeholder="Whatsapp Template Language"
					            optionLabel="label"
					            optionValue="value"
					            class="w-100"/>
				    </div>
				    
				    <div class="col-md-6 mb-4"
				         v-if="template.communicationWays!==null && template.communicationWays.includes('WHATSAPP')">
					    <FormLabel label-text="WhatsApp Template"
					               :required="true"/>
					    <InputText v-model="template.whatsappTemplate"
					               placeholder="Name of the template"
					              class="w-100 normal-text"/>
				    </div>
					
<!-- WhatsApp Template Type -->
<div class="col-md-6 mb-4"
     v-if="template.communicationWays!==null && template.communicationWays.includes('WHATSAPP')">

    <FormLabel label-text="WhatsApp Template Type"
               :required="true"/>

    <Select
        v-model="template.whatsappTemplateType"
        :options="whatsappTemplateTypes"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Template Type"
        class="w-100"/>
</div>


		    
<!-- WhatsApp Param Count -->
<div class="col-md-6 mb-4"
    v-if="
   template.communicationWays!==null &&
   template.communicationWays.includes('WHATSAPP')
">

    <FormLabel label-text="WhatsApp Parameter Count"
               :required="true"/>

    <InputText
        v-model="template.whatsappParamCount"
        type="number"
        placeholder="Enter parameter count"
        class="w-100"/>
</div>


<div class="col-md-12 mb-4"
     v-if="template.communicationWays!==null 
     && template.communicationWays.includes('WHATSAPP')">

    <FormLabel label-text="WhatsApp Text"
               :required="false"/>

    <Textarea
        v-model="template.whatsappText"
        rows="6"
        class="w-100"
        placeholder="Enter WhatsApp text with variables"/>
</div>


<!-- WhatsApp Header URL -->
<div class="col-md-12 mb-4"
     v-if="template.communicationWays!==null 
     && template.communicationWays.includes('WHATSAPP') 
     && template.whatsappTemplateType !== 'TEXT'">

    <FormLabel label-text="WhatsApp Header URL"
               :required="true"/>

    <InputText
        v-model="template.whatsappHeaderUrl"
        placeholder="Enter Image / Video / Document URL"
        class="w-100 normal-text"/>
</div>

				    
				    <div class="col-md-12"
				         v-if="template.communicationWays!==null && template.communicationWays.includes('SMS')">
					    <FormLabel label-text="Sms Message"
					               :required="true"/>
					    <Textarea class="w-100 normal-text"
					              placeholder="Message Text"
					              rows="7"
					              :auto-resize="true"
					              v-model="template.smsText"/>
				    </div>


<div class="col-md-12 mb-4"
     v-if="template.communicationWays!==null
     && template.communicationWays.includes('SMS')">

    <FormLabel
            label-text="DLT Template ID"
            :required="true"/>

    <InputText
            v-model="template.smsDltTemplateId"
            placeholder="DLT Template ID"
            class="w-100"/>

</div>

			    </div>
			    
			    <div class="col-md-12 mt-3">
				    <Button class="w-100"
				            :label="(typeof this.template.id!=='undefined') ? 'Update' : 'Save'"
				            @click="save"
				            :icon="(typeof this.template.id!=='undefined') ? 'pi pi-refresh' : 'pi pi-save'"
				            severity="primary"/>
			    </div>
		    </DashboardCard>
	    </div>
    </DashboardContainer>
</template>


<script>
import DashboardCard from "@/dashboard/containers/DashboardCard.vue";
import DashboardContainer from "@/dashboard/containers/DashboardContainer.vue";
import CheatCode from "@/dashboard/communication/components/CheatCode.vue";
import Button from "primevue/button";
import Select from "primevue/select";
import Editor from "primevue/editor";
import Textarea from "primevue/textarea";
import InputText from "primevue/inputtext";
import FormLabel from "@/components/FormLabel.vue";
import {TEMPLATE_MODEL, TEMPLATE_STYLE, WHATSAPP_LANGUAGES} from "@/dashboard/communication/utils/template";
import {COMMUNICATION_WAY} from "@/dashboard/church/church";
import {isEmpty} from "@/utils/AppStringUtils";
import {AVAILABLE_LANGUAGES} from "@/dashboard/organization/Organization";
import Checkbox from "primevue/checkbox";
export default {
    name: "CreateTemplate",
    components: {
		CheatCode,
	    Select,
	    DashboardContainer,
	    DashboardCard,
	    Button,
	    Editor,
	    Textarea,
	    FormLabel,
	    InputText},
        Checkbox,
    data(){
        return{
           template : {
   ...this.templateData,
   whatsappTemplateType: this.templateData.whatsappHeaderType || "TEXT"
},
            isEditing : false,
	        templateStyle: [...TEMPLATE_STYLE],
            data : null,
            updateTemplate : null,
	        selectedCommunicationWays: [],
			whatsappTemplateTypes: [
            { label: "Text", value: "TEXT" },
            { label: "Image", value: "IMAGE" },
            { label: "Video", value: "VIDEO" },
            { label: "File", value: "DOCUMENT" }
        ]
        }
    },
    methods:{
        save: function(){

			
             let data = this.$root['addInstitutionId'](this.template);
			 data = {
				 ...data,
				 communicationWays: data.communicationWays!==null ? [data.communicationWays] : null
			 };

			 if (
        data.communicationWays?.includes("WHATSAPP") &&
        isEmpty(data.whatsappTemplateType)
    ) {
        this.$root['showAlert'](
            'warn',
            "Template",
            "Please select WhatsApp Template Type"
        );
        return;
    }
			 

	// WhatsApp header URL validation
if (
    data.communicationWays?.includes("WHATSAPP") &&
    data.whatsappTemplateType !== "TEXT" &&
    isEmpty(data.whatsappHeaderUrl)
) {
    this.$root['showAlert'](
        'warn',
        "Template",
        "Please enter WhatsApp Header URL"
    );
    return;
}

// WhatsApp param count validation
if (
    data.templateStyle === "WHATSAPP_RECEIPT" &&
    
  (isEmpty(data.whatsappParamCount) || Number(data.whatsappParamCount) < 0)
) {
    this.$root['showAlert'](
        'warn',
        "Template",
        "Please enter valid WhatsApp Parameter Count"
    );
    return;
}

 // ✅ AUTO WHATSAPP TEMPLATE CONFIG
    if (data.communicationWays?.includes("WHATSAPP")) {

        if (data.whatsappTemplateType === "TEXT") {
            data.whatsappHeaderType = null;
            data.whatsappHeaderUrl = null;
            data.whatsappHeaderFilename = null;
        } else {
    data.whatsappHeaderType = data.whatsappTemplateType;

    if (!data.whatsappParamCount) {
        data.whatsappParamCount = 0;
    }

    if (data.whatsappHeaderUrl) {
        const parts = data.whatsappHeaderUrl.split('/');
        data.whatsappHeaderFilename = parts[parts.length - 1];
    }
}
       data.whatsappParamCount = data.whatsappParamCount || 0;
    }
           if (
    isEmpty(data.emailText) &&
    isEmpty(data.smsText) &&
  
    isEmpty(data.whatsappTemplate)
) {
    this.$root['showAlert']('warn', "Template", "At least one message should be set.");
    return;
}

if (
    data.communicationWays?.includes("SMS") &&
    isEmpty(data.smsDltTemplateId)
) {
    this.$root['showAlert'](
        'warn',
        "Template",
        "Please enter DLT Template ID"
    );
    return;
}

            this.$api.post("/communication/template/save", data).then(response=>{
                this.template = {...TEMPLATE_MODEL};
	            this.$root['showAlert']("success", "Template", response.message);
            }).catch(error=>{
                this.$root['handleApiError'](error, "Template");
            });
        },

		resetTemplate() {
    this.template = { ...TEMPLATE_MODEL };
    this.$root['showAlert'](
        'success',
        'Template',
        'Form refreshed successfully'
    );
}

    },
    
    props:{
	    templateData:{
            type: Object,
		    required: false,
            default(){
                return {...TEMPLATE_MODEL};
            }
        }
    },
    computed:{
	    whatsappLanguages: function(){
			return [...AVAILABLE_LANGUAGES].filter(language=>WHATSAPP_LANGUAGES.includes(language.value));
	    },

		
	    communicationWays: function(){
		    return [...COMMUNICATION_WAY].filter(way=>{
				let ACCEPTED = ["SMS", "MAIL", "WHATSAPP"];
				return ACCEPTED.includes(way.value);
		    });
	    },
    },

	watch: {
    'template.whatsappTemplateType'(val) {
        if (val === 'TEXT') {
            this.template.whatsappHeaderUrl = null;
        }
    }
}
   
}
</script>


<style scoped lang="scss">
</style>